const Colors = {
  primary: "#FFB800",
  orange: "#FF7700",
  orangeDark: "#EA5C00",
  purple: "#771DB0",
  purpleDark: "#4B146D",
  pink: "#C5054E",
  yellow: "#FFC70D",
  red: "#AC2121",
  redLight: "#E64B00",
  cardGradient: "linear-gradient(180deg, #FFF1E7 0%, rgba(255, 241, 231, 0) 100%)",
};

export default Colors;
